import React, { useState } from 'react';
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonInput,
    IonItem,
    IonLabel,
    IonTextarea,
    IonButton,
    IonToast,
    IonCard,
} from '@ionic/react';
import Header from './Header';
import Footer from './Footer';

const AboutUs: React.FC = () => {
    return (
        <>
            <IonContent>
                <Header />
                <IonCard className='privacy-policy-section'>
                    <h1 className='text-center font-50'>About Us</h1>
                    <div className='mt-5'>
                        <p><strong>MamasGuidance.com</strong> is a joyful learning platform designed especially for early learners — from Nursery. Our mission is to make foundational education fun, accessible, and engaging for children aged from 3 years.</p>

                        <h2>Our Vision</h2>
                        <p>We believe every child deserves a strong and happy start in their educational journey. Our goal is to spark curiosity and build confidence in young learners through playful and meaningful content.</p>

                        <h2>What We Offer</h2>
                        <ul>
                            <li>Interactive and printable worksheets across English, Maths, EVS, and Logical Reasoning</li>
                            <li>Olympiad preparation materials (IMO, NSO, IEO, IGKO, etc.) from Class 1</li>
                            <li>Visual learning activities, picture-based questions, and concept builders</li>
                            <li>Curriculum-aligned content for CBSE, ICSE, and major state boards</li>
                        </ul>

                        <h2>Why Choose Us?</h2>
                        <p>We design every resource with care to ensure it is child-friendly, parent-approved, and teacher-supported. Whether your child is learning at home or in a classroom, MamasGuidance provides the support they need to thrive.</p>

                        <h2>Who We Are</h2>
                        <p>We are a team of educators, designers, and parents who understand the unique needs of early learners. With experience in curriculum design and child development, we’re here to make learning a joyful experience for every child.</p>

                        <h2>Join Our Learning Journey</h2>
                        <p>Whether you&apos;re a parent looking for helpful worksheets, a teacher seeking creative material, or a student ready to explore, MamasGuidance is here for you. Explore, learn, and grow with us!</p>

                        <p>Want to get in touch? <a href="/contact-us">Contact us here</a> or email: <a href="mailto:support@mamasguidance.com">support@mamasguidance.com</a></p>
                    </div>
                </IonCard>
                <Footer />
            </IonContent>
        </>
    );
};

export default AboutUs;